import { UserOutlined } from '@ant-design/icons';
import { Avatar, Button, Layout, Menu, Typography } from 'antd';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { envApiUrl } from '../../fetchHooks/envApiUrl';
import { useUserProfile } from '../../fetchHooks/useUserProfile';
import { LanguageSwitcher } from '../LanguageSwitcher/LanguageSwitcher';
import './Navbar.scss';
import type { MenuItemType } from 'antd/es/menu/interface';
import BlurScreenWhenInactive from '../BlurScreenWhenInactive/BlurScreenWhenInactive';
const { Text } = Typography;
export const isMobile = window.innerWidth < 500;

type NavbarProps = {
  month?: number;
  hidden?: boolean;
};

const Navbar = ({ month, hidden = false }: NavbarProps) => {
  const { t } = useTranslation();
  const {
    data: userProfile,
    userHasServiceSimplified,
    userHasServiceMydays,
    userHasServicePasswords,
    userHasServiceSalary,
    userIsMaster,
  } = useUserProfile();
  const isFurutoppen = userProfile?.username === 'furutoppen';
  const handleSignOut = () => {
    window.location.href = '/signout';
  };

  if (hidden) return;

  const menuItems = () => [
    {
      key: -1,
      // label: <Logo size="medium" showText={true} linkTo="/" className="navbar-logo" />,
      label: (
        <a href="/">
          <img src="/favicon.svg" alt="LifeLog Logo" className="navbar-logo" />
        </a>
      ),
    },
    userHasServiceMydays && {
      key: 0,
      label: <Link to={`/myday`}>{!userHasServiceSimplified ? t('navigation.myLifelogs') : 'Hyttebok'}</Link>,
    },
    userHasServiceSalary && {
      key: 1,
      label: (
        <Link to={`/registrations?year=${new Date().getFullYear()}&month=${new Date().getMonth() + 1}`}>
          {!userHasServiceSimplified ? t('navigation.salary') : 'Kalender'}
        </Link>
      ),
    },
    userHasServicePasswords && {
      key: 3,
      label: <Link to={`/mypasswords`}>{t('navigation.passwords')}</Link>,
    },
    userHasServiceSalary &&
      !userHasServiceSimplified && {
        key: 2,
        label: <Link to={`/year?year=${new Date().getFullYear()}`}>{t('navigation.yearlyStats')}</Link>,
      },
    userIsMaster && {
      key: 4,
      label: <Link to={`/admin`}>{t('navigation.admin')}</Link>,
    },

    {
      label: userProfile?.username ? (
        <>
          <Text style={{ color: 'inherit' }}>
            {userProfile?.firstname} ({userProfile?.role})
          </Text>
          <Link to="/profile">
            <Avatar
              size={50}
              style={{
                marginLeft: 16,
                marginTop: '-5px',
                backgroundColor: 'rgba(53, 58, 69, 1)',
                outline: '3px solid rgb(180, 247, 200)',
              }}
              src={
                userProfile?.settings?.profilePictureFileId
                  ? `${envApiUrl}/files/image/${userProfile.settings.profilePictureFileId}`
                  : userProfile?.settings?.profilePicURL
              }
              icon={
                userProfile?.settings?.profilePictureFileId || userProfile?.settings?.profilePicURL ? undefined : (
                  <UserOutlined />
                )
              }
            />
          </Link>
        </>
      ) : (
        <span>{t('auth.login')}</span>
      ),
    },
    {
      label: (
        <Button
          onClick={handleSignOut}
          style={{ color: 'inherit', borderColor: 'inherit', background: 'transparent', border: 'none' }}
        >
          {t('auth.logout')}
        </Button>
      ),
    },
    {
      label: <LanguageSwitcher />,
    },
  ];
  return (
    <Layout style={{ background: 'transparent' }}>
      {!isFurutoppen && <BlurScreenWhenInactive />}
      <Menu
        theme="dark"
        mode="horizontal"
        defaultSelectedKeys={[`${month}`]}
        items={menuItems() as MenuItemType[]}
        className="navbar"
        style={{
          borderRadius: 8,
          height: 64,
          display: 'flex',
          alignItems: 'center',
          ...((import.meta as { env?: { VITE_ENVIRONMENT?: string } }).env?.VITE_ENVIRONMENT === 'development' && {
            backgroundColor: 'darkgreen',
            color: '#00ff00',
          }),
        }}
      />
    </Layout>
  );
};

export default Navbar;
